export enum CatalogueSortBy {
  Title = 0,
  PublishedEndDate = 1,
  Listed = 2,
  SaleDate = 3,
  Flock = 5,
  Location = 6,
  SaleType = 4,

  // TODO
  // Update numbers when sorting by lot, price and dose will be available
  Lot = 7,
  Price = 8,
  Dose = 9,
}
